// extracted by mini-css-extract-plugin
export var errorIcon = "_op-1";
export var nameLogo = "_op-0";